import('./AppBootstrap')
  .then(async ({ renderApp }) => {
    await renderApp();
  })
  .catch(error => {
    console.error('Failed to bootstrap af_shared_user:', error);
  });

export {};
